import React, { useEffect } from 'react';

const GoogleTranslateInit = () => {
    useEffect(() => {
        if (window.googleTranslateElementInit) return;

        // Inizializza il Widget
        window.googleTranslateElementInit = () => {
            new window.google.translate.TranslateElement(
                {
                    pageLanguage: 'it',
                    includedLanguages: 'it,en,fr,es,de',
                    layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
                    autoDisplay: false,
                },
                'google_translate_element'
            );
        };

        const clearAllGoogtrans = () => {
            console.log("[CraftOnline] Resetting to Italian base language.");
            const domain = window.location.hostname;

            // Migliorata la pulizia dei cookie per catturare anche domini di root (es. sitename.com invece di www.sitename.com)
            const domainParts = domain.split('.');
            const baseDomain = domainParts.length > 1 ? `.${domainParts.slice(-2).join('.')}` : domain;

            const domains = [domain, `.${domain}`, baseDomain, ''];
            const paths = ['/', window.location.pathname];

            domains.forEach(d => {
                paths.forEach(p => {
                    const domainStr = d ? `; domain=${d}` : '';
                    document.cookie = `googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${p}${domainStr}`;
                });
            });

            try {
                localStorage.removeItem('googtrans');
                sessionStorage.removeItem('googtrans');
                // Pulisce anche altre eventuali chiavi sporche di Google
                for (let i = 0; i < localStorage.length; i++) {
                    const key = localStorage.key(i);
                    if (key && key.includes('goog')) localStorage.removeItem(key);
                }
            } catch (e) { console.error(e); }

            document.documentElement.classList.remove('translated-ltr', 'translated-rtl');
        };

        const injectScript = () => {
            if (document.querySelector('script[src*="translate.google.com"]')) return;
            const addScript = document.createElement('script');
            addScript.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
            document.body.appendChild(addScript);
        };

        const startLogic = () => {
            // Controlla se l'utente ha una preferenza manuale
            const manualLang = localStorage.getItem('craftonline_manual_lang');

            if (!manualLang || manualLang === 'it') {
                // LINGUA BASE: Puliamo tutto e NON INIETTIAMO lo script.
                // Niente script = zero possibilità di traduzione automatica.
                clearAllGoogtrans();
                window.dispatchEvent(new CustomEvent('craftonline-language-set', { detail: 'it' }));
            } else {
                // LINGUA STRANIERA: Impostiamo il cookie e iniettiamo lo script.
                console.log("[CraftOnline] Restoring manual language preference:", manualLang);
                document.cookie = `googtrans=/it/${manualLang}; path=/`;
                window.dispatchEvent(new CustomEvent('craftonline-language-set', { detail: manualLang }));
                injectScript();
            }
        };

        startLogic();
    }, []);

    return <div id="google_translate_element" style={{ display: 'none' }}></div>;
};

export default GoogleTranslateInit;